import { OptionItem } from "@/components/Dropdown/model";

export const ROLE_OPTIONS: OptionItem[] = [
  { label: "Customer", value: "customer" },
  { label: "Admin", value: "admin" },
  { label: "Super Admin", value: "super_admin" },
];

export const GENDER_OPTIONS: OptionItem[] = [
  { label: "Male", value: "laki-laki" },
  { label: "Female", value: "perempuan" },
];

export const ERROR_FIELD = {
  // fullname: "Must be filled, and has minimum 8 character",
  fullname: "Must be filled",
  username: "Must be filled, and hasn't contain white space",
  email: "Must be filled, and has email format",
  phonNumber: "Must be filled, and has minimum 10 character",
  dob: "Must be filled",
  password: "Must be filled, and similar with confirm password",
  confirmPassword: "Must be filled, and similar with password",
};

export const VALID_IMAGE_TYPE = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/gif",
  "image/svg",
];
